/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { AboutTheChildScreen2Component} from './about_the_child_screen_2.component';

export class AboutTheChildScreen2Validation extends IValidator {

       constructor(private component: AboutTheChildScreen2Component) {
             super();
       }

       private success: boolean;

       public validate(): boolean {

            this.success = true;

            // add your valdation here!

            return this.success;

       }
}

